import React, { useEffect, useState } from 'react';
import HealthDataBaseTable from './HealthDataBaseTable';
import { IHealthData } from '../../Hooks/useHealthData';
import { HealthDataFilterFormValues } from '../Filter/HealthDataFilterForm';
import { Table } from '../../Enums/Table.enum';
import { ITableColumn } from '../../../../Models/Table/ITableColumn';
import useTable from '../../Hooks/useTable';
import QuestionnaireResultTableItem from '../../../../Components/Questionnaire/QuestionnaireResultTableItem';
import { useAppContext } from '../../../../Services/AppContext';
import { getMomentDate } from '../../../../Utils/dates.util';
// @ts-ignore
import styles from './HealthDataVerticalTable.module.scss';
import useTranslation from '../../../../Hooks/useTranslation';

interface HealthDataVerticalTable {
	healthData: IHealthData[];
	isLoading: boolean;
	filter: HealthDataFilterFormValues;
	tableName: Table;
	tableTitle?: string;
}

const HealthDataVerticalTable: React.FC<HealthDataVerticalTable> = props => {
	const { healthData, isLoading, filter, tableName, tableTitle } = props;
	const { dateFormatMoment } = useAppContext();
	const { t } = useTranslation();

	const [rows, setRows] = useState<object[]>([]);
	const [columns, setColumns] = useState<ITableColumn[]>([]);
	const { getVerticalTableData } = useTable();

	const defaultColumns: ITableColumn[] = [
		{
			key: 'name',
			title: t('component.healthData.data'),
			minWidth: '200px',
			maxWidth: '300px',
			fixed: true,
			renderItem: item => {
				return (
					<QuestionnaireResultTableItem
						value={item.name}
						color='#fff'
						textColor='#000'
						className={styles.rowTitle}
					/>
				);
			},
		},
	];

	useEffect(() => {
		if (healthData) {
			const { columns, rows } = getVerticalTableData(
				healthData,
				tableName,
				filter.view,
				filter.type,
			);
			setColumns([...defaultColumns, ...columns]);
			setRows(rows);
		}
	}, [healthData]);

	const from = getMomentDate(filter.from).format(dateFormatMoment);
	const to = getMomentDate(filter.to).format(dateFormatMoment);

	let finalTableTitle = from;
	if (from != to) {
		finalTableTitle = from + ' - ' + to;
	}

	if (tableTitle) {
		finalTableTitle = tableTitle;
	}

	return (
		<HealthDataBaseTable
			title={finalTableTitle}
			rows={rows}
			columns={columns}
			isLoading={isLoading}
		/>
	);
};

export default HealthDataVerticalTable;
